module.exports = __webpack_public_path__ + "static/media/Dr.046492bb.jpeg";